__turbopack_context__.v({
  "canScroll": "style-module-scss-module__bFYVVa__canScroll",
  "scrollInner": "style-module-scss-module__bFYVVa__scrollInner",
  "scrollOuter": "style-module-scss-module__bFYVVa__scrollOuter",
  "scrolledLeft": "style-module-scss-module__bFYVVa__scrolledLeft",
  "scrolledRight": "style-module-scss-module__bFYVVa__scrolledRight",
});
